@if (changeButtonConfigurations.enabled && !configuration.changeFileButtonDisabled) {
	<section class="flex justify-end mb-[20px]">
		<button (click)="editData()" [disabled]="isDisabled" class="btn-primary btn-type-1">
			@if (!changeButtonConfigurations.loading) {
				<span>{{ changeButtonConfigurations.label }}</span>
			}
			@if (changeButtonConfigurations.loading) {
				<img class="forgot-loading" src="../../../../assets/icons/loading-points.svg" />
			}
		</button>
	</section>
}

<section>
	@if (loadConfiguration) {
		<lbca-sub-module-file-upload
			[idEntity]="context.id"
			(setHasFile)="setHasFile($event)"
			[cardData]="cardInfo"
			[properties]="configuration"
			[disabled]="disableControl"
			[dataAttr]="dataAttr"
			[editFilesContext]="context.id"
		></lbca-sub-module-file-upload>
	}
</section>

@if (context.courtHearingAttendanceType === 'virtual') {
	<lbca-input-link (audienceLink)="linkAud($event)"
		[disabled]="isDisabled"
		[lane]="context"
	 />
}

<ng-template #templateFeedbackRedirect>
	<div class="text-base text-font flex items-center justify-center show">
		{{ templateFeedbackRedirectMessage }}
		<div class="emojis-smile icon-box ml-[16px]"></div>
	</div>
</ng-template>
